export default __webpack_public_path__ + "static/media/portfolio.ea98705a.png";